module.exports = __webpack_public_path__ + "img/dashboard-revise.4a4c3db3.svg";